import envDetect from '@tcc/env-detect';
import { queryParam } from './queryString';

const seasonSpecificMockFiles = {
  'legend/actualpopulation': {
    '2016:sugarbeets:US:2:SPR': 'populationWeight',
  },
  'planting/plantingMetadata': {
    '2015:soybeans:US:2:SPR': 'actualEvent',
    '2016:sugarbeets:US:2:SPR': 'populationWeight',
  },
  'legend/harvestdate': {
    '2023:corn-silage:US:2:SPR': '2023harvestDate',
    '2023:sugarcane:US:2:SPR': '2023harvestDate',
  },
};

/**
 * Determines whether or not mocks are allowed and enabled.
 * Mocks are allowed in local dev/CI only.
 * Mocks are enabled by passing ?mocks=true as a query string param.
 * @return {Boolean}  True if mocks are on, false if not
 */
export function shouldUseMocks() {
  const mocksRequested = Boolean(
    queryParam('mocks') || new URLSearchParams(window.location.search).get('mocks')
  );
  const runningInCypress = typeof window !== 'undefined' && Boolean(window.Cypress);

  return mocksRequested && (!envDetect.isEC2() || runningInCypress);
}

/**
 * Checks if a mock JSON file for the specified mockDirPath and season exists. If it exists
 * return it. Otherwise, return the default mock file for the specified mockDirPath.
 * @param {String} mockDirPath - Folder path to the desired mock files
 * @param {String} season - Requested season to find a specific mock file for
 * @return {String} - File path to mock json file
 */
export function getSeasonSpecificMockFile(mockDirPath, season) {
  const mockFile =
    seasonSpecificMockFiles[mockDirPath] &&
    seasonSpecificMockFiles[mockDirPath][season];
  return `${mockDirPath}/${mockFile || 'default'}`;
}

/**
 * Determines which file should be serve for the user mocks
 * @param {String} [file = farmer]
 * @param {Boolean} [isProxying = false]
 * @return {String} filePath
 */
export function getUserMockFile(file = 'farmer', isProxying = false) {
  const userFile = queryParam('userMock');
  const proxyingFile = queryParam('userProxyingMock');

  if (isProxying && proxyingFile) {
    return proxyingFile;
  }

  return userFile || file;
}

/**
 * Determines which file should be serve for the user mocks
 * @param {String} [file = 'farmer']
 * @return {String} filePath
 */
export function getWamMockFile(file = 'farmer') {
  const mockFile = queryParam('wamMock');
  return mockFile || file;
}

/**
 * Determines whether to use the sharingEdit.json in place of the sharing.json mock for the
 * sharingRequester
 * @return {Boolean}  True if sharingEdit mock is on, false if not
 */
export function shouldUseMockSharingEdit() {
  return Boolean(queryParam('sharingEdit'));
}

/**
 * Determines whether to use the sharingEditWithoutYield.json in place of the sharing.json
 * mock for the sharingRequester
 * @return {Boolean}  True if sharingEdit mock is on, false if not
 */
export function shouldshouldUseMockSharingEditWithoutYield() {
  return Boolean(queryParam('sharingEditWithoutYield'));
}

/**
 * Determines whether to use the noData.json in place of the default.json
 * mock for the precisionPlantingRequester
 * @return {Boolean}  True if noData mock is on, false if not
 */
export function shouldUseMockWithoutSeasonData() {
  return Boolean(queryParam('noData'));
}

/**
 * Determines whether to use the cropWaterData.json in place of the default.json
 * mock for the mosaicRequester
 * @return {Boolean}  True if cropWaterData mock is on, false if not
 */
export function shouldUseMockWithCropWaterUseData() {
  return Boolean(queryParam('cropWaterData'));
}
